export const ZeroStateIcon = () => (
  <svg fill="none" height="36" viewBox="0 0 40 36" width="40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M24.9618 32.6003H9.92084C9.60559 32.6003 9.34766 32.3424 9.34766 32.0271V18.3125C9.34766 17.9972 9.60559 17.7393 9.92084 17.7393H24.9618C25.2771 17.7393 25.535 17.9972 25.535 18.3125V32.0271C25.535 32.3424 25.2771 32.6003 24.9618 32.6003Z"
      fill="#CDD3DD"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M25.535 18.3124V19.5952H9.34766V18.3124C9.34766 17.9974 9.6055 17.7393 9.92084 17.7393H24.9618C25.2771 17.7393 25.535 17.9974 25.535 18.3124Z"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.8689 18.7157C10.8689 18.96 10.6709 19.158 10.4266 19.158C10.1824 19.158 9.98438 18.96 9.98438 18.7157C9.98438 18.4714 10.1824 18.2734 10.4266 18.2734C10.6709 18.2734 10.8689 18.4714 10.8689 18.7157Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.2986 18.7157C12.2986 18.96 12.1006 19.158 11.8563 19.158C11.6121 19.158 11.4141 18.96 11.4141 18.7157C11.4141 18.4714 11.6121 18.2734 11.8563 18.2734C12.1006 18.2734 12.2986 18.4714 12.2986 18.7157Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M13.7263 18.7157C13.7263 18.96 13.5283 19.158 13.2841 19.158C13.0398 19.158 12.8418 18.96 12.8418 18.7157C12.8418 18.4714 13.0398 18.2734 13.2841 18.2734C13.5283 18.2734 13.7263 18.4714 13.7263 18.7157Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M26.7313 35.6692H11.6904C11.3751 35.6692 11.1172 35.4112 11.1172 35.096V21.3813C11.1172 21.0661 11.3751 20.8081 11.6904 20.8081H26.7313C27.0466 20.8081 27.3045 21.0661 27.3045 21.3813V35.096C27.3045 35.4112 27.0466 35.6692 26.7313 35.6692Z"
      fill="#E4E8EE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M27.3045 21.3813V22.6641H11.1172V21.3813C11.1172 21.0662 11.375 20.8081 11.6904 20.8081H26.7313C27.0467 20.8081 27.3045 21.0662 27.3045 21.3813Z"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.6404 21.7846C12.6404 22.0288 12.4424 22.2268 12.1981 22.2268C11.9539 22.2268 11.7559 22.0288 11.7559 21.7846C11.7559 21.5403 11.9539 21.3423 12.1981 21.3423C12.4424 21.3423 12.6404 21.5403 12.6404 21.7846Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.0701 21.7846C14.0701 22.0288 13.8721 22.2268 13.6278 22.2268C13.3836 22.2268 13.1855 22.0288 13.1855 21.7846C13.1855 21.5403 13.3836 21.3423 13.6278 21.3423C13.8721 21.3423 14.0701 21.5403 14.0701 21.7846Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.4959 21.7846C15.4959 22.0288 15.2979 22.2268 15.0536 22.2268C14.8094 22.2268 14.6113 22.0288 14.6113 21.7846C14.6113 21.5403 14.8094 21.3423 15.0536 21.3423C15.2979 21.3423 15.4959 21.5403 15.4959 21.7846Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M38.0145 25.175H22.9736C22.6584 25.175 22.4004 24.9171 22.4004 24.6018V10.8871C22.4004 10.5719 22.6584 10.314 22.9736 10.314H38.0145C38.3298 10.314 38.5878 10.5719 38.5878 10.8871V24.6018C38.5878 24.9171 38.3298 25.175 38.0145 25.175Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <mask height="3" id="mask0_1565_98011" maskUnits="userSpaceOnUse" width="17" x="22" y="10">
      <path
        clipRule="evenodd"
        d="M22.4004 10.3022H38.5878V12.1582H22.4004V10.3022Z"
        fill="white"
        fillRule="evenodd"
      />
    </mask>
    <g mask="url(#mask0_1565_98011)">
      <path
        clipRule="evenodd"
        d="M38.5878 10.8754V12.1582H22.4004V10.8754C22.4004 10.5604 22.6582 10.3022 22.9736 10.3022H38.0146C38.3299 10.3022 38.5878 10.5604 38.5878 10.8754Z"
        fill="#CDD3DD"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M23.9099 11.2802C23.9099 11.5244 23.7119 11.7224 23.4677 11.7224C23.2234 11.7224 23.0254 11.5244 23.0254 11.2802C23.0254 11.0359 23.2234 10.8379 23.4677 10.8379C23.7119 10.8379 23.9099 11.0359 23.9099 11.2802Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M25.3377 11.2802C25.3377 11.5244 25.1397 11.7224 24.8954 11.7224C24.6511 11.7224 24.4531 11.5244 24.4531 11.2802C24.4531 11.0359 24.6511 10.8379 24.8954 10.8379C25.1397 10.8379 25.3377 11.0359 25.3377 11.2802Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M26.7654 11.2802C26.7654 11.5244 26.5674 11.7224 26.3231 11.7224C26.0789 11.7224 25.8809 11.5244 25.8809 11.2802C25.8809 11.0359 26.0789 10.8379 26.3231 10.8379C26.5674 10.8379 26.7654 11.0359 26.7654 11.2802Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 27.6866H32.7022V27.0142H29.1719V27.6866Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 28.6871H39.2264V28.3726H29.1719V28.6871Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 30.5064H39.5626V30.1919H29.1719V30.5064Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 31.4156H40.0029V31.1011H29.1719V31.4156Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 32.3253H35.7521V32.0107H29.1719V32.3253Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.1719 29.5953H40.0029V29.2808H29.1719V29.5953Z"
      fill="#EEF1F6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.98438 11.9322H13.1338V11.2598H9.98438V11.9322Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.98438 12.9327H18.954V12.6182H9.98438V12.9327Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.98438 14.7506H19.254V14.436H9.98438V14.7506Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.98438 15.6602H16.8127V15.3457H9.98438V15.6602Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.98438 13.8409H19.6468V13.5264H9.98438V13.8409Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <g filter="url(#filter0_d_1565_98011)">
      <mask height="22" id="mask1_1565_98011" maskUnits="userSpaceOnUse" width="17" x="16" y="12">
        <path
          clipRule="evenodd"
          d="M16.5098 12.2725H32.8412V33.707H16.5098V12.2725Z"
          fill="white"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask1_1565_98011)">
        <path
          clipRule="evenodd"
          d="M32.3427 33.707H17.0083C16.7341 33.707 16.5098 33.4827 16.5098 33.2086V12.7709C16.5098 12.4968 16.7341 12.2725 17.0083 12.2725H32.3427C32.6169 12.2725 32.8412 12.4968 32.8412 12.7709V33.2086C32.8412 33.4827 32.6169 33.707 32.3427 33.707Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M20.875 21.5786H31.134V21.1816H20.875V21.5786Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 22.4077H28.1023V22.0107H20.875V22.4077Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 31.8461H27.8799V31.3003H20.875V31.8461Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18.7308 22.7869C18.1849 22.7869 17.7383 22.3404 17.7383 21.7946C17.7383 21.2488 18.1849 20.8022 18.7308 20.8022C19.2767 20.8022 19.7233 21.2488 19.7233 21.7946C19.7233 22.3404 19.2767 22.7869 18.7308 22.7869Z"
        fill="#E4E8EE"
        fillRule="evenodd"
        stroke="#E4E8EE"
        strokeWidth="0.176004"
      />
      <path
        clipRule="evenodd"
        d="M18.7308 29.3841C18.1849 29.3841 17.7383 28.9375 17.7383 28.3917C17.7383 27.8459 18.1849 27.3994 18.7308 27.3994C19.2767 27.3994 19.7233 27.8459 19.7233 28.3917C19.7233 28.9375 19.2767 29.3841 18.7308 29.3841Z"
        fill="#E4E8EE"
        fillRule="evenodd"
        stroke="#E4E8EE"
        strokeWidth="0.176004"
      />
      <path
        clipRule="evenodd"
        d="M18.7308 26.0862C18.1849 26.0862 17.7383 25.6397 17.7383 25.0939C17.7383 24.5481 18.1849 24.1016 18.7308 24.1016C19.2767 24.1016 19.7233 24.5481 19.7233 25.0939C19.7233 25.6397 19.2767 26.0862 18.7308 26.0862Z"
        fill="#E4E8EE"
        fillRule="evenodd"
        stroke="#E4E8EE"
        strokeWidth="0.176004"
      />
      <path
        clipRule="evenodd"
        d="M20.875 24.8764H31.134V24.4795H20.875V24.8764Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 25.707H28.1023V25.3101H20.875V25.707Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 28.1758H31.134V27.7788H20.875V28.1758Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 29.0049H28.1023V28.6079H20.875V29.0049Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.7383 18.0811L18.4668 18.657L19.758 17.1641"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        d="M17.7383 18.0811L18.4668 18.657L19.758 17.1641"
        stroke="#E4E8EE"
        strokeWidth="0.264005"
      />
      <path
        clipRule="evenodd"
        d="M17.7383 14.7823L18.4668 15.3582L19.758 13.8652"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        d="M17.7383 14.7823L18.4668 15.3582L19.758 13.8652"
        stroke="#E4E8EE"
        strokeWidth="0.264005"
      />
      <path
        clipRule="evenodd"
        d="M20.875 14.3389H31.134V13.8369H20.875V14.3389Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 15.3878H28.1023V14.8857H20.875V15.3878Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.4648 14.0869H31.545H20.4648Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M20.4648 14.0869H31.545" stroke="#E4E8EE" strokeWidth="0.0880018" />
      <path
        clipRule="evenodd"
        d="M20.4648 15.1372H28.4939H20.4648Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M20.4648 15.1372H28.4939" stroke="#E4E8EE" strokeWidth="0.0880018" />
      <path
        clipRule="evenodd"
        d="M20.875 17.6368H31.134V17.1348H20.875V17.6368Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.875 18.6861H28.1023V18.1841H20.875V18.6861Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M20.4648 17.3858H31.545H20.4648Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M20.4648 17.3858H31.545" stroke="#E4E8EE" strokeWidth="0.0880018" />
      <path
        clipRule="evenodd"
        d="M20.4648 18.4356H28.4939H20.4648Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M20.4648 18.4356H28.4939" stroke="#E4E8EE" strokeWidth="0.0880018" />
      <path
        clipRule="evenodd"
        d="M18.2832 19.8984H31.0117H18.2832Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M18.2832 19.8984H31.0117" stroke="#E4E8EE" strokeWidth="0.0880018" />
      <path
        clipRule="evenodd"
        d="M18.7295 30.8101V32.3377V30.8101Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M18.7295 30.8101V32.3377" stroke="#E4E8EE" strokeWidth="0.264005" />
      <path
        clipRule="evenodd"
        d="M17.9668 31.5737H19.4947H17.9668Z"
        fill="#E4E8EE"
        fillRule="evenodd"
      />
      <path d="M17.9668 31.5737H19.4947" stroke="#E4E8EE" strokeWidth="0.264005" />
    </g>
    <g filter="url(#filter1_d_1565_98011)">
      <circle cx="15.0441" cy="16.0441" fill="#CDD3DD" r="15.0441" />
      <mask height="30" id="mask2_1565_98011" maskUnits="userSpaceOnUse" width="30" x="0" y="1">
        <circle cx="15.0435" cy="16.0445" fill="#F8F9FB" r="14.3951" />
      </mask>
      <g mask="url(#mask2_1565_98011)">
        <rect fill="white" height="31.1359" transform="translate(0 0.162598)" width="31.0101" />
        <rect fill="#A8B1BD" height="3.0172" rx="0.167622" width="3.0172" x="3.26953" y="4.52002" />
        <rect fill="#A8B1BD" height="3.0172" rx="0.167622" width="3.0172" x="3.26953" y="17.1758" />
        <rect fill="#A8B1BD" height="3.0172" rx="0.167622" width="3.0172" x="3.26953" y="26.0186" />
        <rect fill="#A8B1BD" height="3.0172" rx="0.167622" width="3.0172" x="3.26953" y="9.04541" />
        <rect
          fill="#CDD3DD"
          height="1.17336"
          rx="0.167622"
          width="10.9793"
          x="6.87305"
          y="4.52002"
        />
        <rect
          fill="#CDD3DD"
          height="1.17336"
          rx="0.167622"
          width="10.9793"
          x="6.87305"
          y="17.1758"
        />
        <rect
          fill="#CDD3DD"
          height="1.17336"
          rx="0.167622"
          width="10.9793"
          x="6.87305"
          y="26.0186"
        />
        <rect
          fill="#CDD3DD"
          height="1.17336"
          rx="0.167622"
          width="10.9793"
          x="6.87305"
          y="9.04541"
        />
        <rect
          fill="#EEF1F6"
          height="0.880018"
          rx="0.167622"
          width="10.9793"
          x="3.26953"
          y="2.34131"
        />
        <rect
          fill="#EEF1F6"
          height="0.880018"
          rx="0.167622"
          width="10.9793"
          x="3.26953"
          y="14.9971"
        />
        <rect
          fill="#EEF1F6"
          height="0.880018"
          rx="0.167622"
          width="10.9793"
          x="3.26953"
          y="23.8389"
        />
        <rect
          fill="#EEF1F6"
          height="1.17336"
          rx="0.167622"
          width="8.50684"
          x="6.87305"
          y="6.36377"
        />
        <rect
          fill="#EEF1F6"
          height="1.17336"
          rx="0.167622"
          width="8.50684"
          x="6.87305"
          y="19.0195"
        />
        <rect
          fill="#EEF1F6"
          height="1.17336"
          rx="0.167622"
          width="8.50684"
          x="6.87305"
          y="27.8613"
        />
        <rect
          fill="#EEF1F6"
          height="1.17336"
          rx="0.167622"
          width="8.50684"
          x="6.87305"
          y="10.8892"
        />
        <rect
          fill="#A8B1BD"
          height="1.17336"
          rx="0.167622"
          width="5.15439"
          x="21.666"
          y="5.44238"
        />
        <rect
          fill="#A8B1BD"
          height="1.17336"
          rx="0.167622"
          width="5.15439"
          x="21.666"
          y="18.0972"
        />
        <rect
          fill="#A8B1BD"
          height="1.17336"
          rx="0.167622"
          width="5.15439"
          x="21.666"
          y="26.9399"
        />
        <rect
          fill="#A8B1BD"
          height="1.17336"
          rx="0.167622"
          width="5.15439"
          x="21.666"
          y="9.96826"
        />
        <path d="M2.64062 8.25H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 20.9058H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 29.7476H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 12.7759H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 3.72412H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 16.3799H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 25.2217H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 8.25H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 20.9058H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
        <path d="M2.64062 29.7476H27.4487" stroke="#E4E8EE" strokeWidth="0.0838112" />
      </g>
    </g>
    <path
      d="M24.1888 27.3166L24.4326 27.0728L25.6395 27.8404L32.2915 34.4924C32.4911 34.6919 32.4911 35.0154 32.2915 35.215C32.092 35.4145 31.7685 35.4145 31.569 35.215L24.9487 28.5947L24.1888 27.3166Z"
      fill="#CDD3DD"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="22.1051"
        id="filter0_d_1565_98011"
        width="17.0025"
        x="16.1745"
        y="12.0629"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="0.125717" />
        <feGaussianBlur stdDeviation="0.167622" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.4 0 0 0 0 0.458824 0 0 0 0.15 0"
        />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1565_98011" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1565_98011"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="31.7646"
        id="filter1_d_1565_98011"
        width="31.7641"
        x="-0.838112"
        y="0.580944"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="0.419056" />
        <feGaussianBlur stdDeviation="0.419056" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.4 0 0 0 0 0.458824 0 0 0 0.16 0"
        />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1565_98011" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1565_98011"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
